import Vue from 'vue';

import Loading from '@/components/elements/loading';
import Attachment from '@/components/elements/attachment';
import SupportCode from '@/components/elements/support-code';
import ListView from '@/components/elements/list-view';

import InputSwitch from '@/components/forms/input-switch';
import ImageInput from '@/components/forms/image-input';
import InputEmail from '@/components/forms/input-email';
import InputPhone from '@/components/forms/input-phone';
import InputSelect from '@/components/forms/input-select';
import InputColor from '@/components/forms/input-color';
import InputWysiwyg from '@/components/forms/input-wysiwyg';

Vue.component('loading', Loading);
Vue.component('attachment', Attachment);
Vue.component('support-code', SupportCode);
Vue.component('list-view', ListView);

Vue.component('input-switch', InputSwitch);
Vue.component('image-input', ImageInput);
Vue.component('input-email', InputEmail);
Vue.component('input-phone', InputPhone);
Vue.component('input-select', InputSelect);
Vue.component('input-color', InputColor);
Vue.component('input-wysiwyg', InputWysiwyg);

